import React, { useLayoutEffect, useState } from "react";
import { getPrismicItems } from "../../actions/prismicAction";
import { useDispatch } from "react-redux";
import getFirebase from "../../firebase";
import { useParams } from "react-router";
import CarpenterView from "./CarpenterView";
import {doc, getDoc, getFirestore} from "firebase/firestore";

const CarpenterProvider = (props) => {
  const { id } = props;
  const params = useParams();
  const dispatch = useDispatch();
  /**
   * @type {[tulu.Item]}
   */

  const [data, setData] = useState();

  useLayoutEffect(() => {
    dispatch(getPrismicItems());

    let docId;
    id ? (docId = id) : (docId = params.id);

    getFirebase();

    const db = getFirestore(getFirebase());

    const docRef = doc(db, "my_tulu", docId);

    getDoc(docRef).then((res) => {
      const response = res.data();
      response.columns = JSON.parse(response.columns);
      response.rideItems = JSON.parse(response.rideItems);
      setData(response);
    });
    // Mount-once initial fetch: dispatch is stable, and id/params.id identify
    // this proposal for the whole lifetime; re-running on change would change behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{data && <CarpenterView data={data} />}</>;
};

export default CarpenterProvider;
